import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "titlePages" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "titleSNR" }
const _hoisted_5 = { class: "titleSNR" }

import {  onMounted, ref, computed, Ref } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import CardTopology from '@/components/SmartLink/topology/CardTopology.vue';
import CompareCharts from '@/components/SmartLink/charts/CompareCharts.vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import store from '@/store';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { STRING_GENERAL } from '@/constants/labels';
import { LABELS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';

/********************************
 ********** INTERFACES **********
 *******************************/
import { HEADER } from '@/interfaces/SmartLink/Tables';
import { OBJSNR } from '@/interfaces/SmartLink/IA'

/********************************
 *********** SERVICES ***********
 *******************************/
import { getAllPredictionPREDSNRByIP, getAllPredictionREALSNRByIP, getAllPredictionSNRData, getAllPredictionTABSNRByIP } from '@/services/Smartlink/Predict';


/**
 * Header de la tabla
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'PredictSNRView',
  setup(__props) {

const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const HEADERS__PRIMARY_TABLE:(HEADER)[]    = [
{ text: computed(() => t('labels.date')).value,     value: "fecha",       sortable: true },
{ text: computed(() => t('labels.ip')).value,       value: "ip",          sortable: true },
{ text: computed(() => t('labels.status')).value,   value: "status",      sortable: true },
{ text: computed(() => t('labels.cause')).value,    value: "causa",       sortable: true },
{ text: computed(() => t('labels.value')).value,    value: "value",       sortable: true },
]    


/**
 * Se hace así para poder utilizar el i18n (verificarlo)
 */
const headers:(HEADER)[] = HEADERS__PRIMARY_TABLE;

/**
 * Mostrar el dialogo
 */
const dialog                        = ref(false);

/**
 * Valor Predictivo Horizontal para el gráfico
 */
const valorPredHOR:Ref<number[][]>  = ref([]);

/**
 * Valor Predictivo Vertical para el gráfico
 */
const valorPredVER:Ref<number[][]>  = ref([]);

/**
 * Valor Real Horizontal para el gráfico
 */
const valorRealHOR:Ref<number[][]>  = ref([]);

/**
 * Valor Real Vertical para el gráfico
 */
const valorRealVER:Ref<number[][]>  = ref([]);

/**
 * Item de la Tabla Horizontal
 */
const itemsHOR:Ref<OBJSNR[]>        = ref([]);

/**
 * Item de la Tabla Vertical
 */
const itemsVER:Ref<OBJSNR[]>        = ref([]);

/**
 * Nombre del equipo seleccionado para mostrar el Dialogo
 */
const titleDialog                   = ref('');

/**
 * Fecha del Predict Vertical del equipo seleccionado para mostrar el Dialogo
 */
const titleDateVER                  = ref('');

/**
 * Valor del Predict Vertical del equipo seleccionado para mostrar el Dialogo
 */
const titleValueVER                 = ref('');

/**
 * Fecha del Predict Horizontal del equipo seleccionado para mostrar el Dialogo
 */
const titleDateHOR                  = ref('');

/**
 * Valor del Predict Horizontal del equipo seleccionado para mostrar el Dialogo
 */
const titleValueHOR                 = ref('');

/**
 * Lista de equipos que tienen Predict 
 */
const arrayPredictSNR               = ref();

/**
 * Muestra un texto en caso no hay información en la DB o si hay algún error con las APIS
 */
const showError                     = ref(false);

/**
 * Muestra la información requerida desde la API
 */
const showCard                      = ref(true);

async function getPredictSNRData() {
    arrayPredictSNR.value = [];

    const allData = await getAllPredictionSNRData()

    showCard.value = allData.showGraphs;
    showError.value = !allData.showGraphs;

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        arrayPredictSNR.value = allData.data
    }
}

/**
 * Mostrar el dialogo con los gráficos del equipo
 * @param ip captura la IP
 * @param name captura el NOMBRE
 */
async function showDialog (ip:string, name:string) {
    titleDialog.value   = name;
    dialog.value        = true;
    valorPredVER.value  = [];
    valorPredHOR.value  = [];
    valorRealVER.value  = [];
    valorRealHOR.value  = [];
    itemsVER.value      = [];
    itemsHOR.value      = [];

    let params = { ip: ip };

    const allDataPRED = await getAllPredictionPREDSNRByIP(params)

    if( allDataPRED.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allDataPRED.status === 200 ){
        valorPredVER.value = allDataPRED.data.predVER
        valorPredHOR.value = allDataPRED.data.predHOR
        if(valorPredVER.value.length > 0) {
            let fechaVer        = new Date(valorPredVER.value.slice(-1)[0][0] + (300 * 60 * 1000) );
            titleDateVER.value  = fechaVer.toLocaleString( "es-PE");
            titleValueVER.value = (valorPredVER.value.slice(-1)[0][1]).toString();
        }
        
        if(valorPredHOR.value.length > 0) {
            let fechaHor        = new Date(valorPredHOR.value.slice(-1)[0][0] + (300 * 60 * 1000) );
            titleDateHOR.value  = fechaHor.toLocaleString("es-PE");
            titleValueHOR.value = (valorPredHOR.value.slice(-1)[0][1]).toString();
        }
    }


    const allDataREAL = await getAllPredictionREALSNRByIP(params)

    if( allDataREAL.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allDataREAL.status === 200 ){
        valorRealVER.value = allDataREAL.data.realVER
        valorRealHOR.value = allDataREAL.data.realHOR
    }

    const allDataTAB = await getAllPredictionTABSNRByIP(params)

    if( allDataTAB.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allDataTAB.status === 200 ){
       itemsVER.value = allDataTAB.data.tabVER
       itemsHOR.value = allDataTAB.data.tabHOR
    }
}

onMounted(async () => {
    await getPredictSNRData();  
})


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "defaultCard",
    color: "bgtopology"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('analyticsPage.titlesnr')), 1),
      (showCard.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "ma-0"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrayPredictSNR.value, (item, i) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  class: "my-3",
                  cols: "12",
                  sm: "4",
                  md: "3",
                  lg: "2",
                  xl: "2",
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createVNode(CardTopology, {
                      status: item.status,
                      ip: item.ip,
                      title: item.name,
                      description: item.tipo,
                      onClick: ($event: any) => (showDialog(item.ip,item.name))
                    }, null, 8, ["status", "ip", "title", "description", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode(_component_v_dialog, {
                modelValue: dialog.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
                width: "85%"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "card_dialog",
                    color: "background"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "ma-0",
                        justify: "space-between",
                        style: {"align-items":"self-end !important"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "10" }, {
                            default: _withCtx(() => [
                              (_unref(xs))
                                ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_unref(t)('title.graphTitle')) + " " + _toDisplayString(titleDialog.value), 1))
                                : (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(t)('title.graphTitle')) + " " + _toDisplayString(titleDialog.value), 1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                icon: "mdi-close",
                                variant: "plain",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
                              })
                            ]),
                            _: 1
                          }),
                          (valorPredVER.value.length !== 0)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                style: _normalizeStyle(_unref(xs) ? 'text-align:start' :'text-align:end'),
                                class: "pb-1"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(_unref(xs) ? 'datePredict' : '')
                                  }, _toDisplayString(_unref(t)('analyticsPage.valueVert')) + " [ " + _toDisplayString(titleDateVER.value) + " ] - " + _toDisplayString(_unref(t)('analyticsPage.titleDial2')) + " " + _toDisplayString(titleValueVER.value), 3)
                                ]),
                                _: 1
                              }, 8, ["style"]))
                            : _createCommentVNode("", true),
                          (valorPredHOR.value.length !== 0)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "12",
                                style: _normalizeStyle(_unref(xs) ? 'text-align:start' :'text-align:end'),
                                class: "pt-1"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(_unref(xs) ? 'datePredict' : '')
                                  }, _toDisplayString(_unref(t)('analyticsPage.valueHorz')) + " [ " + _toDisplayString(titleDateHOR.value) + " ] - " + _toDisplayString(_unref(t)('analyticsPage.titleDial2')) + " " + _toDisplayString(titleValueHOR.value), 3)
                                ]),
                                _: 1
                              }, 8, ["style"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_sheet, {
                        class: "defaultCard text-center",
                        color: "bgtopology"
                      }, {
                        default: _withCtx(() => [
                          (valorRealHOR.value.length !== 0)
                            ? (_openBlock(), _createBlock(CompareCharts, {
                                key: 0,
                                "name-primary": "Real",
                                "first-array": valorRealHOR.value,
                                "color-first": _unref(COLOR).compare3,
                                "color-second": _unref(COLOR).compare2,
                                "name-secundary": _unref(t)('labels.predict'),
                                "second-array": valorPredHOR.value,
                                subtitle: '',
                                title: _unref(t)('analyticsPage.predvsreal2') + ' Horizontal' ,
                                typeChart: _unref(STRING_GENERAL).predictsnr
                              }, null, 8, ["first-array", "color-first", "color-second", "name-secundary", "second-array", "title", "typeChart"]))
                            : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_sheet, {
                        class: "defaultCard text-center",
                        color: "bgtopology"
                      }, {
                        default: _withCtx(() => [
                          (valorRealVER.value.length !== 0)
                            ? (_openBlock(), _createBlock(CompareCharts, {
                                key: 0,
                                "name-primary": "Real",
                                "first-array": valorRealVER.value,
                                "color-first": _unref(COLOR).compare3,
                                "color-second": _unref(COLOR).compare2,
                                "name-secundary": _unref(t)('labels.predict'),
                                "second-array": valorPredVER.value,
                                subtitle: '',
                                title: _unref(t)('analyticsPage.predvsreal2') + ' Vertical' ,
                                typeChart: _unref(STRING_GENERAL).predictsnr
                              }, null, 8, ["first-array", "color-first", "color-second", "name-secundary", "second-array", "title", "typeChart"]))
                            : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_sheet, {
                        class: "defaultCard text-center",
                        color: "bgtopology"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(t)('analyticsPage.snrHorz')), 1),
                          (itemsHOR.value.length !== 0)
                            ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                key: 0,
                                "table-class-name": "customize-table",
                                "show-index": "",
                                headers: _unref(headers),
                                items: itemsHOR.value.slice(0,10),
                                "hide-footer": ""
                              }, null, 8, ["headers", "items"]))
                            : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_sheet, {
                        class: "defaultCard text-center",
                        color: "bgtopology"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(t)('analyticsPage.snrVert')), 1),
                          (itemsVER.value.length !== 0)
                            ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                key: 0,
                                "table-class-name": "customize-table",
                                "show-index": "",
                                headers: _unref(headers),
                                items: itemsVER.value.slice(0,10),
                                "hide-footer": ""
                              }, null, 8, ["headers", "items"]))
                            : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (showError.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: "ma-0 py-3 px-4"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h3", null, _toDisplayString(_unref(t)('noInformation')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})